import { render, staticRenderFns } from "./GiftCardsSuccess.vue?vue&type=template&id=8909458e"
import script from "./GiftCardsSuccess.vue?vue&type=script&lang=js"
export * from "./GiftCardsSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports